import React from 'react';
import Form from 'react-bootstrap/Form';

import TextArea from '../TextArea';

export default React.forwardRef(
  ({ field, form, label, regex, max, handleChange, ...props }, ref) => {
    return (
      <Form.Group
        style={{ marginBottom: '32px', width: '100%' }}
        controlId={field && field.name}
        className={props.className}
      >
        {label && <Form.Label>{label}</Form.Label>}
        <TextArea
          data-testid='form'
          {...field}
          {...props}
          isInvalid={form && form.touched[field.name] && !!form.errors[field.name]}
          onChange={(event) => {
            if (props.onChange) {
              props.onChange(event);
            } else {
              form.setFieldValue(field.name, event.target.value.replace(regex, '').slice(0, max));
              handleChange && handleChange(event.target.value.replace(regex, '').slice(0, max));
            }
          }}
          ref={ref}
        />
        <Form.Control.Feedback type='invalid'>
          {form && form.errors[field.name]}
        </Form.Control.Feedback>
      </Form.Group>
    );
  }
);
